import React, { Component } from "react";
import { Table, Segment } from "semantic-ui-react";

class EmployeeEducation extends Component {
  renderEmployeeEduction(education) {
    if (education && education.length > 0) {
      return education.map(emp => {
        return (
          <Table.Row key={emp.Id}>
            <Table.Cell>
              {emp.DegreeName}
            </Table.Cell>
            <Table.Cell>
              {emp.CompletedYear}
            </Table.Cell>
            <Table.Cell>
              {emp.Institute}
            </Table.Cell>
            <Table.Cell>
              {emp.MajorSubjects}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }

  render() {
    let { education } = this.props;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Employee Education</h1>
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Degree</Table.HeaderCell>
                <Table.HeaderCell>Year of Passing</Table.HeaderCell>
                <Table.HeaderCell>University Institute</Table.HeaderCell>
                <Table.HeaderCell>Major Subjects</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.renderEmployeeEduction(education)}
            </Table.Body>
          </Table>
        </Segment>
      </Segment.Group>
    );
  }
}

export default EmployeeEducation;
